export default {
  backToListings: {
    id: 'transfer_methods_confirmation_back_to_listings',
    defaultMessage: 'Back to my listings',
  },
  surtitle: {
    id: 'transfer_methods_confirmation_surtitle',
    defaultMessage: 'Hip hip hip hooray!',
  },
  title: {
    id: 'transfer_methods_confirmation_title',
    defaultMessage: 'Congratulations!',
  },
  description: {
    id: 'transfer_methods_confirmation_description',
    defaultMessage:
      'Your information have successfully be sent to our partner Hyper Wallet and will be reviewed within the next 3 business days. After validation, you’ll be able to sell in new markets.',
  },
  pageTitle: {
    id: 'transfer_methods_confirmation_page_title',
    defaultMessage: 'Transfer methods confirmation',
  },
}
